import React from 'react'
import { Link } from "react-router-dom"
import './ErrorPage.sass'

const ErrorPage = () => {
    return (
        <div className="bg content-error">
            <p className="error">Error 404 page not found</p>
            <Link to="/home">Go back home</Link>
        </div>
    )
}
export default ErrorPage